import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const MatchBridge = () => {
  // 1. App.js의 라우터에서 ':token' 부분으로 설정한 값을 쏙 빼옵니다.
  const { token } = useParams();

  useEffect(() => {
    if (!token) return;

    // 2. app.json에 등록된 scheme인 "mobile"을 사용하여 딥링크 주소 조립
    const appLink = `taimtalk://match/${token}`;

    // 3. 페이지가 열리자마자 무작정 앱 열기 시도 (앱이 있으면 여기서 폰이 알아서 낚아챔)
    window.location.href = appLink;

    // 4. 타이머 세팅: 2.5초 뒤에도 유저가 이 화면을 보고 있다면 앱이 없는 것으로 간주
    const fallbackTimer = setTimeout(() => {
      const userAgent = navigator.userAgent.toLowerCase();
      
      if (userAgent.indexOf("android") > -1) {
        // 안드로이드: app.json에 등록된 패키지명으로 플레이스토어 이동
        window.location.href = "https://play.google.com/store/apps/details?id=com.taim.taimtalk";
      } else if (userAgent.indexOf("iphone") > -1 || userAgent.indexOf("ipad") > -1) {
        // iOS: 애플 앱스토어 링크 (❗나중에 앱스토어에 출시하시면 id 뒤에 부여받은 번호를 적어주세요)
        window.location.href = "https://apps.apple.com/kr/app/taim-talk/id6758910290";
      } else {
        // PC 등 기타 환경일 경우 홈으로 보내거나 안내 문구 표시
        window.location.href = "/";
      }
    }, 2500); 

    // 컴포넌트가 꺼지면 타이머도 깔끔하게 청소
    return () => clearTimeout(fallbackTimer);
  }, [token]);

  return (
    // 0.1초 찰나에 보일 수도 있는 화면이므로 앱의 메인 테마 색상(#090A0F)으로 깔끔하게 맞춤
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#090A0F', color: 'white' }}>
      <h2>TAIM 앱으로 이동 중입니다 🚀</h2>
      <p style={{ color: '#aaa', marginTop: '10px' }}>화면이 넘어가지 않는다면 앱을 설치해 주세요!</p>
    </div>
  );
};

export default MatchBridge;